import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SchemaOrg from '../../components/feature/SchemaOrg';
import MiniPriceSimulator from '../../components/feature/MiniPriceSimulator';

const SITE_URL = 'https://transporteurexpressidf.fr';

export default function CoursierParisPage() {
  useEffect(() => {
    document.title = "Coursier Paris | Transporteur Express IDF - Livraison Urgente, Utilitaire avec Chauffeur 24/7";

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Transporteur Express IDF : coursier Paris express, location camion utilitaire avec chauffeur, aide au déménagement, aide au chargement. Livraison urgente en 30 min, 24h/7j. Devis gratuit !');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'coursier Paris, coursier express IDF, livraison urgente Paris, coursier moto Paris, location camion utilitaire avec chauffeur Paris, aide au déménagement Paris, aide au chargement Paris, coursier voiture Paris, livraison 1h Paris, coursier 24h Paris, transport express IDF, coursier professionnel Paris, livraison rapide Paris, transporteur coursier Paris, porteur déménagement Paris');
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${SITE_URL}/coursier-paris`);
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Coursier Paris | Transporteur Express IDF - Livraison Urgente, Utilitaire avec Chauffeur 24/7');
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Transporteur Express IDF : coursier Paris express, location camion utilitaire avec chauffeur, aide au déménagement, aide au chargement. Livraison urgente en 30 min, 24h/7j.');
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', `${SITE_URL}/coursier-paris`);
    }

    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', 'Coursier Paris | Transporteur Express IDF - Livraison Urgente, Utilitaire avec Chauffeur 24/7');
    }

    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', 'Transporteur Express IDF : coursier Paris express, location camion utilitaire avec chauffeur, aide au déménagement, aide au chargement. Livraison urgente en 30 min, 24h/7j.');
    }

    const geoRegion = document.querySelector('meta[name="geo.region"]');
    if (geoRegion) geoRegion.setAttribute('content', 'FR-IDF');

    const geoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (geoPlacename) geoPlacename.setAttribute('content', 'Paris, Île-de-France');

    const geoPosition = document.querySelector('meta[name="geo.position"]');
    if (geoPosition) geoPosition.setAttribute('content', '48.8566;2.3522');

    const icbm = document.querySelector('meta[name="ICBM"]');
    if (icbm) icbm.setAttribute('content', '48.8566, 2.3522');

    const lastModified = document.querySelector('meta[name="last-modified"]');
    if (lastModified) lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg type="Service" description="Service de coursier express à Paris et Île-de-France avec livraison en moins d'une heure" />

      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <Link to="/" className="flex items-center gap-3 group">
              <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <i className="ri-truck-line text-2xl text-white"></i>
              </div>
              <span className="text-2xl font-bold bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent">
                Speed Transport
              </span>
            </Link>

            <div className="hidden lg:flex items-center gap-6">
              <a
                href="tel:+33632410246"
                className="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors font-medium"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>+33 6 32 41 02 46</span>
              </a>
              <a
                href="#contact"
                className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-2.5 rounded-full font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300 whitespace-nowrap"
              >
                Devis Gratuit
              </a>
            </div>
          </div>
        </div>
      </nav>
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-green-50 to-green-100 py-20 pb-16">
          <div className="max-w-6xl mx-auto px-4">
            <div className="text-center mb-16">
              <h1 className="text-5xl font-black text-gray-900 mb-6 font-inter">
                Le spécialiste du transport délicat et sécurisé à Paris
              </h1>
              <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
                <strong>Transport objets fragiles Paris</strong> avec manutention délicate et soin extrême. Notre service spécialisé dans le <strong>transport d'œuvres d'art</strong>, mobilier de luxe et objets de valeur. <strong>Speed Transport</strong> : assurance complète incluse, équipe experte disponible 24/7.
              </p>
              <div className="mt-8 text-sm text-gray-500">
                <p>Services spécialisés par zone : <a href="/transporteur-express-nanterre" className="text-green-600 hover:underline">Coursier Nanterre</a>, <a href="/transporteur-palettes-rungis" className="text-green-600 hover:underline">Transport Rungis</a>, <a href="/livraison-urgente-evenementiel-villepinte" className="text-green-600 hover:underline">Événementiel Villepinte</a></p>
              </div>
            </div>
            
            <div className="text-center">
              <a 
                href="tel:+33632410246"
                className="inline-flex items-center px-8 py-4 bg-green-600 text-white text-lg font-semibold rounded-full hover:bg-green-700 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line w-5 h-5 mr-3"></i>
                Transport Sécurisé +33 6 32 41 02 46
              </a>
            </div>
          </div>
        </section>

        {/* Mini Price Simulator */}
        <MiniPriceSimulator />

        {/* Services Coursier */}
        <section className="py-20">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Services Coursier Paris
            </h2>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-e-bike-2-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Coursier Moto Paris</h3>
                <p className="text-gray-600 mb-4">
                  Coursier moto Paris ultra-rapide pour livraisons express. Livraison moto dans Paris centre en 30 minutes maximum, évite tous les embouteillages.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Livraison Paris 30 min</li>
                  <li>• Coursier moto rapide</li>
                  <li>• Évite embouteillages</li>
                  <li>• Suivi temps réel</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-truck-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Coursier Utilitaire</h3>
                <p className="text-gray-600 mb-4">
                  Coursier utilitaire Paris pour gros colis et livraisons volumineuses. Camionnette équipée pour transport sécurisé de tous types de marchandises.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Transport gros colis</li>
                  <li>• Camionnette équipée</li>
                  <li>• Livraison volumineuse</li>
                  <li>• Chauffeur professionnel</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-file-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Coursier Documents</h3>
                <p className="text-gray-600 mb-4">
                  Coursier documents Paris sécurisé pour entreprises. Livraison plis confidentiels, dossiers urgents, contrats avec service express garanti.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Plis confidentiels</li>
                  <li>• Documents urgents</li>
                  <li>• Service entreprise</li>
                  <li>• Sécurité maximale</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-time-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Livraison Urgente</h3>
                <p className="text-gray-600 mb-4">
                  Livraison urgente Paris 24/7 pour toutes situations d'urgence. Coursier express disponible immédiatement pour vos besoins critiques.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Service 24/7</li>
                  <li>• Intervention immédiate</li>
                  <li>• Coursier d'urgence</li>
                  <li>• Weekend et jours fériés</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-shopping-bag-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Livraison E-commerce</h3>
                <p className="text-gray-600 mb-4">
                  Livraison e-commerce Paris rapide pour boutiques en ligne. Coursier spécialisé dans la livraison colis clients avec service premium.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Livraison e-commerce</li>
                  <li>• Colis clients</li>
                  <li>• Service boutique</li>
                  <li>• Livraison premium</li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-restaurant-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Livraison Restaurant</h3>
                <p className="text-gray-600 mb-4">
                  Livraison restaurant Paris pour établissements. Coursier alimentaire rapide avec sacs isothermes pour maintenir la qualité des plats.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Livraison alimentaire</li>
                  <li>• Sacs isothermes</li>
                  <li>• Service restaurant</li>
                  <li>• Livraison chaude</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Avantages Coursier */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Pourquoi Choisir Notre Coursier Paris ?
            </h2>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="bg-white p-6 rounded-xl shadow-md text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-timer-flash-line text-2xl text-green-600"></i>
                </div>
                <h4 className="font-bold text-lg mb-3">Livraison Express</h4>
                <p className="text-gray-600 text-sm">
                  Coursier Paris en 30 minutes maximum dans Paris centre. Service express garanti.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-2xl text-green-600"></i>
                </div>
                <h4 className="font-bold text-lg mb-3">Sécurité Garantie</h4>
                <p className="text-gray-600 text-sm">
                  Coursiers professionnels formés, assurance complète, transport sécurisé de vos biens.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-24-hours-line text-2xl text-green-600"></i>
                </div>
                <h4 className="font-bold text-lg mb-3">Service 24/7</h4>
                <p className="text-gray-600 text-sm">
                  Coursier Paris disponible jour et nuit, weekend et jours fériés inclus.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-money-euro-circle-line text-2xl text-green-600"></i>
                </div>
                <h4 className="font-bold text-lg mb-3">Tarifs Compétitifs</h4>
                <p className="text-gray-600 text-sm">
                  Prix coursier Paris transparent et compétitif. Devis gratuit immédiat par téléphone.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Tarifs Coursier */}
        <section className="py-20">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Tarifs Coursier Paris
            </h2>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-e-bike-2-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Coursier Moto</h3>
                <div className="text-4xl font-bold text-green-600 mb-4">Dès 15€</div>
                <ul className="text-gray-600 space-y-2 mb-6">
                  <li>• Paris centre 30 min</li>
                  <li>• Colis jusqu'à 5kg</li>
                  <li>• Suivi temps réel</li>
                  <li>• Livraison express</li>
                </ul>
                <a 
                  href="tel:+33632410246"
                  className="inline-flex items-center px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap"
                >
                  Commander
                </a>
              </div>

              <div className="bg-green-600 p-8 rounded-2xl shadow-lg text-white text-center relative">
                <div className="absolute top-4 right-4 bg-yellow-400 text-green-600 px-3 py-1 rounded-full text-sm font-bold">
                  POPULAIRE
                </div>
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-truck-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Coursier Utilitaire</h3>
                <div className="text-4xl font-bold mb-4">Dès 35€</div>
                <ul className="space-y-2 mb-6">
                  <li>• Paris + banlieue</li>
                  <li>• Gros colis 50kg+</li>
                  <li>• Camionnette équipée</li>
                  <li>• Transport sécurisé</li>
                </ul>
                <a 
                  href="tel:+33632410246"
                  className="inline-flex items-center px-6 py-3 bg-white text-green-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
                >
                  Commander
                </a>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-time-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Coursier Urgence</h3>
                <div className="text-4xl font-bold text-green-600 mb-4">Sur devis</div>
                <ul className="text-gray-600 space-y-2 mb-6">
                  <li>• Service 24/7</li>
                  <li>• Intervention immédiate</li>
                  <li>• Tarif majoré nuit</li>
                  <li>• Devis personnalisé</li>
                </ul>
                <a 
                  href="tel:+33632410246"
                  className="inline-flex items-center px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap"
                >
                  Devis gratuit
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Coursier */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
              Questions Fréquentes Coursier
            </h2>
            
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">En combien de temps le coursier arrive-t-il ?</h3>
                <p className="text-gray-600">
                  Notre coursier Paris arrive en 30 minutes maximum dans Paris centre. Pour la banlieue, délai coursier de 45 minutes à 1 heure selon la zone.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Quel est le poids maximum transportable ?</h3>
                <p className="text-gray-600">
                  Coursier moto jusqu'à 5kg, coursier utilitaire jusqu'à 500kg. Transport gros colis et objets volumineux avec notre camionnette équipée.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Le service coursier fonctionne-t-il la nuit ?</h3>
                <p className="text-gray-600">
                  Oui, notre coursier Paris fonctionne 24h/24 et 7j/7. Service coursier nuit avec tarification spéciale pour les livraisons urgentes.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h3 className="font-bold text-lg mb-3">Comment suivre ma livraison coursier ?</h3>
                <p className="text-gray-600">
                  Suivi coursier en temps réel par SMS et appel. Vous recevez la position du coursier et l'heure d'arrivée estimée automatiquement.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Final */}
        <section className="py-20 bg-green-600 text-white">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold mb-6">
              Besoin d'un Coursier Paris Maintenant ?
            </h2>
            <p className="text-xl mb-8 opacity-90">
              Livraison express, coursier urgent, transport rapide - Appelez-nous !
            </p>
            <a 
              href="tel:+33632410246"
              className="inline-flex items-center px-8 py-4 bg-white text-green-600 text-lg font-semibold rounded-full hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line w-5 h-5 mr-3"></i>
              +33 6 32 41 02 46
            </a>
          </div>
        </section>
      </main>
      
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
